import * as React from 'react'
import { useDataProvider } from 'react-admin'
import { getUserId } from '../providers/cognito'

export const useCourseIds = () => {
  const dataProvider = useDataProvider()
  const [data, setData] = React.useState()

  React.useEffect(() => {
    const userId = getUserId()

    if (!userId) return setData([])

    dataProvider
      .getOne('users', { id: userId })
      .then(({ data } = {}) =>
        setData(data?.type === 'admin' ? undefined : data?.course_ids),
      )
  }, [dataProvider])

  return data
}

export const useAssessmentIds = () => {
  const dataProvider = useDataProvider()
  const [data, setData] = React.useState()
  const [assessments, setAssessments] = React.useState()

  React.useEffect(() => {
    const userId = getUserId()

    if (!userId) return setData([])

    dataProvider
      .getOne('users', { id: userId })
      .then(({ data } = {}) =>
        setData(data?.type === 'admin' ? undefined : data?.course_ids),
      )
  }, [dataProvider])

  React.useEffect(() => {
    if (!data) return
    dataProvider
      .getList('assessments', { filter: { course_id: data } })
      .then(({ data, ...rest }) =>
        setAssessments(data.map((a) => a.sk.split('#')[1])),
      )
  }, [data, dataProvider])

  return assessments
}
